import { generalService } from './general'

export const native = {
  general: generalService,
}
